import { BiReport } from '../services/biService';

export function groupBiReports(
  reports: BiReport[],
): { group: string; reports: BiReport[] }[] {
  const groups: { group: string; reports: BiReport[] }[] = [];

  reports.forEach(report => {
    const group = report.groupNameSamasc || 'Sem grupo';
    const existing = groups.find(item => item.group === group);

    if (existing) {
      existing.reports.push(report);
    } else {
      groups.push({ group, reports: [report] });
    }
  });

  return groups;
}

function normalize(text: string): string {
  // Remove os acentos: "Rações" e "racoes" encontram o mesmo relatório.
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

// Todas as palavras digitadas precisam aparecer no texto, sem diferenciar
// acentos nem maiúsculas.
export function matchesSearch(text: string, search: string): boolean {
  const terms = normalize(search).split(/\s+/).filter(Boolean);
  const haystack = normalize(text);

  return terms.every(term => haystack.includes(term));
}

export function filterBiReports(
  reports: BiReport[],
  search: string,
): BiReport[] {
  if (!search.trim()) {
    return reports;
  }

  return reports.filter(report =>
    matchesSearch(
      [
        report.reportName,
        report.groupNameSamasc,
        report.summary || '',
        report.description || '',
      ].join(' '),
      search,
    ),
  );
}
